<style lang="scss" scoped>
  #account-block {
    color: #3b334a;
    font-family: "Montserrat";
    font-size: 16px;
    font-weight: 400;
    letter-spacing: -0.24px;
    line-height: 24px;
    -webkit-text-stroke: thin;
  }

  h3 {
    color: #3b334a;
    font-family: "Montserrat";
    font-size: 22px;
    font-weight: 400;
    letter-spacing: -0.33px;
    line-height: 30px;
    -webkit-text-stroke: thin;
    margin-top: 15px;
    margin-bottom: 55px;
  }

  label {
    color: #857a98;
    font-family: Montserrat;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0.26px;
    line-height: 25px;
  }

  .border-right {
    border-right: 1px solid #857a98;
    margin-bottom: 60px;
  }
</style>

<template>
  <div id="account-block">
    <div class="row">
      <div class="col-9">
        <h1 class="page-title text-left">
          {{ __('Pagamento') }}
        </h1>
      </div>
      <div class="col-3" />
    </div>
    <div class="row">
      <div class="col-8">
        <h2 class="page-subtitle">
          <IconExclamationTriangle
            color="#F4F2F7"
            :size="24"
          /><b class="ml-10px">{{ __('Olá') }} {{ user.name | firstword }}, {{ __('sua conta está bloqueada') }} :(</b>
        </h2>
      </div>
    </div>
    <div class="row board p-30px">
      <div class="offset-2 col-8">
        <div class="row">
          <div class="col-12 text-center">
            <h3>{{ __('Infelizmente não identificamos o pagamento de sua fatura.') }}</h3>
          </div>
        </div>
        <div
          class="row"
          v-if="invoice && invoice.status === 'pending'"
        >
          <div class="offset-2 col-4 text-center border-right">
            <label>{{ __('Data de vencimento') }}</label><br>{{ invoice.due_at | datetime('LD') }}
          </div>
          <div class="col-4 text-center">
            <label>{{ __('Valor da assinatura') }}</label><br>{{ invoice.total | number }}
          </div>
        </div>
        <div class="row text-center">
          <div class="offset-3 col-6">
            <a
              class="btn btn-primary"
              :href="invoice.url"
              target="_blank"
              v-if="invoice"
            >{{ __('Pagar fatura') }}</a><a
              class="btn btn-primary"
              href="/checkout"
              v-else
            >{{ __('Contratar') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      invoice: null,
    };
  },

  created () {
    this.getLastInvoice();
  },

  methods: {
    getLastInvoice () {
      this.$http.get('/billing/details')
        .then(({ data }) => {
          const invoice = data.tenant.last_invoice;

          if (invoice && invoice.status === 'pending' && invoice.url) {
            this.invoice = invoice;
          }
        });
    },
  },
};
</script>
